export default "__VITE_ASSET__DJHzlAIT__"